<template>
  <div>
    <!-- 管理员添加和详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="addTitle"
      :visible.sync="addInfoVisible"
      :before-close="addInfoHandleClose"
      width="28%"
      center
      top="20vh"
    >
      <el-divider></el-divider>

      <div class="addInfoFrom">
        <el-form ref="form" :model="form" :rules="rules" label-width="90px">
          <el-form-item label="用户名:" prop="user_name">
            <el-input v-model="form.user_name" placeholder="请输入用户名"></el-input>
            <span class="zhu">
              <span>注:</span>
              <span>超级管理员有一次修改用户名的权利</span>
            </span>
          </el-form-item>
          <el-form-item label="密码:"  prop="pwd">
            <el-input v-model="form.pwd" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:"  prop="confirm_pwd">
            <el-input v-model="form.confirm_pwd"  type="password"  placeholder="请再次输入密码"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名:"  prop="Name">
            <el-input v-model="form.Name" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="Email:" prop="E_mail">
            <el-input v-model="form.E_mail" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="角色:" prop="RoleID">
            <el-select v-model="form.RoleID" placeholder="请选择角色" clearable>
              <el-option
                v-for="item in tableData"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <el-button>清空</el-button>
              <el-button class="btnL" @click="administrators('form')">确认添加</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 管理员添加和详情弹框结束 -->
    <!-- 添加角色弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="roleTitle"
      :visible.sync="addroleVisible"
      :before-close="addroleHandleClose"
      width="28%"
      center
      top="30vh"
    >
      <el-divider></el-divider>
      <div class="addroleFrom">
        <el-form ref="forms" :model="form1" :rules="rules1" label-width="90px">
          <el-form-item label="角色名称:" prop="title">
            <el-input v-model="form1.title" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述:" prop="description">
            <el-input type="textarea" v-model="form1.description" placeholder="请输入角色描述内容"></el-input>
          </el-form-item>
          <el-form-item class="bott" label="是否启用:">
            <el-radio-group v-model="form1.status">
              <el-radio label="1">启用</el-radio>
              <el-radio label="2">禁止</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <el-button>清空</el-button>
              <el-button class="btnL" @click="roleBtns('forms')">
                
                {{roleTitle=='角色修改'?'确认修改':'确认添加'}}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 添加角色弹框结束 -->
  </div>
</template>

<script>
import  {addUserInfoTwo,getDisAuthGroupTwoList,getUserInfoTwoInfo,getUserInfoTwoUpdate,addDisAuthGroupTwo,updateDisAuthGroupTwo} from '@/request/index.js'
// import {Userfirst,QueryingUserRoles,AddRule,UpdateRule,List,UpdateAdministrator} from '@/request/scenic.js'
import { Message  } from 'element-ui';
export default {
  props:['UserID','roleID'],
  data() {
    return {
      addInfoVisible: false, // 管理员添加和详情
      addroleVisible: false, // 角色添加
      addTitle: "", // 管理员添加和详情
      roleTitle: "", // 管理员添加和详情
      form: {
        token:window.sessionStorage.getItem('Token'),
        user_name:'',
        RoleID:'',
        E_mail:'',
        pwd:'',
        confirm_pwd:'',
        Name:''
      },
      rules: {
        user_name:[ { required: true, message: '请输入用户姓名', trigger: 'blur' }],
        Name:[ { required: true, message: '请输入姓名', trigger: 'blur' }],
        E_mail:[ { required: true, message: '请输入邮箱地址', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}],
        RoleID:[{ required: true, message: '请选择角色', trigger: 'change' }]
      },
      form1:{
        status:'1',
        title:'',
        description:'',
        token:window.sessionStorage.getItem('Token'),
      },
      rules1: {
        title:[ { required: true, message: '请输入角色名称', trigger: 'blur' }],
        description:[ { required: true, message: '请输入描述', trigger: 'blur' }]
      },
      tableData:[],
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:999
      }
    };
  },
  created(){
    if(this.UserID){
      this.getListrole()
      this.getList()
    }else{
      this.getListrole()
    }
    console.log(this.roleID)
    if(this.roleID){
      this.form1.id = this.roleID.id
      this.form1.title = this.roleID.title 
      this.form1.description = this.roleID.description
      this.form1.status = this.roleID.status + ''
    }
  },
  methods: {
    getListrole(){
      getDisAuthGroupTwoList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
        }
      })
    },
    // 管理员确认
    administrators(form){
      if(this.form.confirm_pwd&&this.form.pwd){
        if(this.form.confirm_pwd!=this.form.pwd){
          Message.error('两次密码不一致')
          return false
        }
      }
      if(this.UserID){
        this.$refs[form].validate((valid) => {
          if (valid) {
            this.form.user_id = this.UserID
            getUserInfoTwoUpdate(this.form).then(res=>{
                if(res.data.status=='ok'){
                  let data  = '1'
                  this.$emit('UserRoles',data)
                  this.addInfoVisible = false
                  this.$message.success('修改管理员成功')
                }else{
                  Message.error(res.data.msg)
                }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }else{
        this.$refs[form].validate((valid) => {
          if (valid) {
            addUserInfoTwo(this.form).then(res=>{
                if(res.data.status=='ok'){
                  let data  = '1'
                  this.$emit('UserRoles',data)
                  this.addInfoVisible = false
                  this.$message.success('添加管理员成功')
                }else{
                  Message.error(res.data.msg)
                }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    // 角色确认
    roleBtns(form){
      if(this.form1.id){
        this.$refs[form].validate((valid) => {
        if (valid) {
          updateDisAuthGroupTwo(this.form1).then(res=>{
            if(res.data.status=='ok'){
              this.form1 = {
                status:'1',
                title:'',
                description:'',
                token:window.sessionStorage.getItem('Token'),
              }
              this.addroleVisible = false
               let data = '1'
               this.$emit('VisibleClose',data);
                this.$message.success('修改角色成功')
            }else{
              Message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      }else{
        this.$refs[form].validate((valid) => {
        if (valid) {
          addDisAuthGroupTwo(this.form1).then(res=>{
            console.log(res)
            if(res.data.status=='ok'){
              this.form1 = {
                status:'1',
                title:'',
                description:'',
                token:window.sessionStorage.getItem('Token'),
              }
              this.addroleVisible = false
               let data = '1'
               this.$emit('VisibleClose',data);
               this.$message.success('添加角色成功')
            }else{
              Message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      }
     
    },
    // 管理员详情
    getList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        user_id:this.UserID
      }
      getUserInfoTwoInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.form={
            token:window.sessionStorage.getItem('Token'),
            pwd:'',
            user_name:res.data.result.UserName,
            confirm_pwd:'',
            E_mail:res.data.result.E_mail,
            Name:res.data.result.Name,
            Phone:res.data.result.Phone,
            RoleID:Number(res.data.result.RoleID) 
          }
        }
      })
    },
    // 角色添加
    addRole(row) {
      if (row) {
        this.roleTitle = "角色修改";
      } else {
        this.roleTitle = "添加角色";
      }
      this.addroleVisible = true;
    },
    // 角色添加X
    addroleHandleClose() {
      let data = '1'
      this.$emit('VisibleClose',data);
      this.addroleVisible = false;
    },
    // 管理员添加和详情
    addInfo(row) {
      if (row) {
        this.addTitle = "详情";
      } else {
        this.addTitle = "添加管理员";
      }
      this.addInfoVisible = true;
    },
    // 管理员添加和详情X
    addInfoHandleClose() {
      this.$emit('UserRoles')
      this.addInfoVisible = false;
    }
  }
};
</script>

<style lang='less' scoped>
.addroleFrom {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #e74c3c;
  }
  .bott{
      margin-bottom: 0px;
  }
}
.addInfoFrom {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -52px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -77px;
    color: #e74c3c;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -64px;
    color: #e74c3c;
  }
  .xingD {
    position: absolute;
    top: 0px;
    left: -54px;
    color: #e74c3c;
  }
  .zhu {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #e74c3c;
    > span:nth-child(1) {
      margin-right: 10px;
    }
  }
}
.btn {
  // margin: 20px 100px 10px 0;
  margin-top: 20px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-form-item__label {
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: right;
  color: #666666;
}
/deep/ .el-dialog{
  min-width:400px;
}
</style>